<template>
    <div class="font-satoshi">
        <metainfo></metainfo>

        <IconSet />

        <!-- <PageHeader /> -->

        <main class="main text-darkerblue">
            <router-view />
        </main>

        <PageFooter />
    </div>
</template>

<script setup>
import { useMeta } from 'vue-meta';
import IconSet from '@/components/IconSet.vue';
// import PageHeader from './components/PageHeader.vue';
import PageFooter from './components/PageFooter.vue';
import { onMounted, onUnmounted } from 'vue';

useMeta({
    // title: 'Case Study Explorer',
    description: 'Explore 5 case studies of PH1 that together demonstrate the variable patient profile associated with this condition',
    og: {
        title: 'Overview of Selected Primary Hyperoxaluria Type 1 (PH1) Case Studies',
        description: 'Explore 5 case studies of PH1 that together demonstrate the variable patient profile associated with this condition',
        url: window.location.href,
        image: `${window.location.origin}/assets/logo.png`,
    },
    // meta: [
    //     { name: 'description', content: 'Explore 5 case studies of PH1 that together demonstrate the variable patient profile associated with this condition' },
    //     { name: 'og:title', content: 'Overview of Selected Primary Hyperoxaluria Type 1 (PH1) Case Studies' },
    //     { name: 'og:description', content: 'Explore 5 case studies of PH1 that together demonstrate the variable patient profile associated with this condition' },
    //     { name: 'og:image', content: `${window.location.origin}/assets/logo.png` },
    //     { name: 'og:url', content: window.location.href },
    // ]
});

onMounted(() => {
    // fix navbar sticking to the top when Case study is used as a sub-page
    document.body.classList.add('overflow-x-clip');
})

onUnmounted(() => {
    document.body.classList.remove('overflow-x-clip');
})
</script>

<style>
.overflow-x-clip {
    overflow-x: clip;
}
</style>
